import { withProps, compose } from 'recompose'
import React from 'react'
import { Link } from 'react-router-dom'
import pluralize from 'pluralize'
import { Button } from '@infotech/base-components'
import { EditIcon } from '@infotech/uikit-icons'

const ACTION_EDIT = `edit`

const EditButtonIcon = <EditIcon className="uikit-icon uikit-icon--centered" />

const getItemId = (itemId) => (itemId ? `/${itemId}` : ``)

const EditButtonInner = ({
  action,
  buttonText,
  query,
  disabled,
  config,
  config: { entityName },
  itemId,
  isOpen,
  toggleOpen,
  parentData,
  ...rest
}) => (
  <div className="modal-button-wrapper action" disabled={disabled}>
    <Link
      to={`/${pluralize.singular(entityName)}/${action}${getItemId(itemId)}`}
      disabled={disabled}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault()
        }
      }}
    >
      <Button
        disabled={disabled}
        {...rest}
      >
        {buttonText}
      </Button>
    </Link>
  </div>
)

export const EditButton = compose(
  withProps(({ checkedRows }) => ({
    action         : ACTION_EDIT,
    disabled       : !checkedRows.length || (checkedRows.length > 1),
    buttonText     : `Редактировать`,
    itemId         : checkedRows[0],
    color     : `transparent`,
  })),
)(EditButtonInner)

export const EditButtonConfig = {
  id       : ACTION_EDIT,
  component: EditButton,
}

export const ReadEditButton = withProps(({ id }) => ({
  action         : ACTION_EDIT,
  itemId: id,
  buttonText: EditButtonIcon,
}))(EditButtonInner)

export const ReadEditButtonConfig = {
  id       : ACTION_EDIT,
  component: ReadEditButton,
  props: {
    className: `mr-2`,
  },
}